import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useTranslation } from '@/i18n'
import type { VersionInfo } from '../../types'

interface VersionNavigatorProps {
  versionInfo: VersionInfo
  onNavigate: (userMsgId: string, direction: 'prev' | 'next') => void
}

export function VersionNavigator({ versionInfo, onNavigate }: VersionNavigatorProps) {
  const { t } = useTranslation()
  const { currentVersion, totalVersions, userMessageId } = versionInfo

  if (totalVersions <= 1) return null

  return (
    <div className="inline-flex items-center gap-0.5 text-gray-500 dark:text-dark-text-muted">
      <button
        type="button"
        onClick={() => onNavigate(userMessageId, 'prev')}
        disabled={currentVersion <= 1}
        className="p-0.5 rounded hover:bg-gray-100 dark:hover:bg-dark-accent transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
        aria-label={t('chatv2:version.previous', { defaultValue: 'Previous version' })}
      >
        <ChevronLeft className="h-4 w-4" />
      </button>
      <span className="text-xs tabular-nums min-w-[2rem] text-center">
        {currentVersion}/{totalVersions}
      </span>
      <button
        type="button"
        onClick={() => onNavigate(userMessageId, 'next')}
        disabled={currentVersion >= totalVersions}
        className="p-0.5 rounded hover:bg-gray-100 dark:hover:bg-dark-accent transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
        aria-label={t('chatv2:version.next', { defaultValue: 'Next version' })}
      >
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  )
}
